import axios from 'axios';
import HttpService from '@/api/HttpService';
import {
  SET_SUGGESTED_ADDRESS,
  SET_SUGGESTED_ADDRESS_TYPE,
  SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
  SET_SUGGESTED_ADDRESS_YES_METHOD,
  SET_SUGGESTED_ADDRESS_YES_CALL,
  HIDE_ACCOUNT_CREATION_MODAL,
  SHOW_ACCOUNT_CREATION_MODAL,
  SET_USER_BY_ADMIN,
  SET_CHANGE_ADDRESS,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    name: '',
    userId: '',
    suggestedAddress: {},
    suggestedAddressType: '',
    isSuggestedAddressModalVisible: false,
    methodForYesButton: undefined,
    suggestedAddressModalYesCall: false,
    isAccountCreationModalVisible: false,
    changeAddress: false,
    userByAdmin: {},
  },
  mutations: {
    [SET_SUGGESTED_ADDRESS](state, address) {
      state.suggestedAddress = Object.assign({}, address);
    },
    [SET_SUGGESTED_ADDRESS_TYPE](state, addressType) {
      state.suggestedAddressType = addressType;
    },
    [SET_SUGGESTED_ADDRESS_MODAL_VISIBLE](state, visible) {
      state.isSuggestedAddressModalVisible = visible;
    },
    [SET_SUGGESTED_ADDRESS_YES_METHOD](state, method) {
      state.methodForYesButton = method;
    },
    [SET_SUGGESTED_ADDRESS_YES_CALL](state, called = false) {
      state.suggestedAddressModalYesCall = called;
    },
    [HIDE_ACCOUNT_CREATION_MODAL](state) {
      state.isAccountCreationModalVisible = false;
    },
    [SHOW_ACCOUNT_CREATION_MODAL](state, { userId, name }) {
      state.userId = userId;
      state.name = name;
      state.isAccountCreationModalVisible = true;
    },
    [SET_USER_BY_ADMIN](state, userByAdmin) {
      state.userByAdmin = Object.assign({}, userByAdmin);
    },
    [SET_CHANGE_ADDRESS](state, change) {
      state.changeAddress = change;
    },
  },
  actions: {
    saveUserProfile(_, { user }) {
      return HttpService.postV2('users/register/provisioning', user);
    },
    updateAccountProvisioned(_, { user }) {
      return HttpService.putV2('users/register/provisioning', user);
    },
    updateDwollaUser(_, user) {
      const socialSecurityNum = user.socialSecurityNum;
      const investor = {
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        email: typeof user.email === 'string' ? user.email.toLowerCase() : '',
        userType: user.userType,
        dateOfBirth: user.dateOfBirth,
        socialSecurityNum: socialSecurityNum.indexOf('x') > -1 ? undefined : socialSecurityNum,
        secondaryEmail: typeof user.secondaryEmail === 'string' ? user.secondaryEmail.toLowerCase() : '',
        primaryPhoneNum: user.primaryPhoneNum,
        secondaryPhoneNum: user.secondaryPhoneNum,
        residentialAddress: user.residentialAddress,
        mailingAddress: user.mailingAddress,
        updateCount: user.updateCount,
        isResidentDefaultAddress: user.isResidentDefaultAddress,
        clientId: user.clientId,
      };
      return HttpService.post('user/edit-dwolla-user', investor)
      .then(response => response)
      .catch((err) => {
        throw err;
      });
    },
    updateUserProfile(_, user) {
      const investor = {
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        email: typeof user.email === 'string' ? user.email.toLowerCase() : '',
        userType: user.userType,
        dateOfBirth: user.dateOfBirth,
        socialSecurityNum: user.socialSecurityNum,
        secondaryEmail: typeof user.secondaryEmail === 'string' ? user.secondaryEmail.toLowerCase() : '',
        primaryPhoneNum: user.primaryPhoneNum,
        secondaryPhoneNum: user.secondaryPhoneNum,
        residentialAddress: user.residentialAddress,
        mailingAddress: user.mailingAddress,
        updateCount: user.updateCount,
        isResidentDefaultAddress: user.isResidentDefaultAddress,
        hasBeenAllowedPOBox: user.hasBeenAllowedPOBox,
      };
      return HttpService.putV2(`users/${user.id}/profile`, investor)
      .then(response => response)
      .catch((err) => {
        throw err;
      });
    },
    updateUserDwollaProfile(_, { user }) {
      return HttpService.post('user/update-dwolla-profile', user);
    },
    setDefaultAccount(_, { accountId, userId }) {
      return HttpService.putV2(`users/${userId}/default-account/${accountId}`);
    },
    getUserProfile() {
      return HttpService.getV2('users/user', { needSSN: true });
    },
    getUserDetail(_, userId) {
      return HttpService.getV2(`users/${userId}`, { needSSN: true })
      .then(response => response)
      .catch((err) => {
        throw err;
      });
    },
    getClientDetail(_, userId) {
      return {
        id: userId,
        mailingAddress: {

        },
        residentialAddress: {

        },
        accounts: {},
      };
    },
    getAddressVerification({ commit }, { addressType, address }) {
      return HttpService.postV2(`address-verification/${addressType}`, address);
    },
    verifyResidentialAddress({ dispatch }, address) {
      return dispatch('getAddressVerification', { addressType: 'residential', address });
    },
    verifyOrganizationAddress({ dispatch }, address) {
      return dispatch('getAddressVerification', { addressType: 'organization', address });
    },
    verifyMailingAddress({ dispatch }, address) {
      return dispatch('getAddressVerification', { addressType: 'mailing', address });
    },
    createAccountAdmin({ commit }, accountObject) {
      let endpoint = '';
      switch (accountObject.accountType) {
        case 'joint':
          endpoint = 'accounts/create-joint';
          break;
        case 'utma-ugma':
          endpoint = 'accounts/create-utma-ugma';
          break;
        default:
          break;
      }
      accountObject.accountType = undefined; // eslint-disable-line no-param-reassign

      return HttpService.post(endpoint, accountObject)
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    createAccountByAdmin({ commit }, { userId, accountObject }) {
      return HttpService.postV2(`users/${userId}/accounts`, accountObject)
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    createOrganizationAccount({ commit }, { accountObject, files }) {
      let endpointUrl = '';
      switch (accountObject.accountType) {
        case 'institution':
          endpointUrl = 'accounts/create-institution';
          break;
        case 'trust':
          endpointUrl = 'accounts/create-trust';
          break;
        default:
          break;
      }
      return HttpService.uploadFilesAndForm(endpointUrl, accountObject, files)
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    createOrganizationByAdmin({ commit }, { accountId, organizationObject }) {
      return HttpService.postV2(`accounts/${accountId}/organizations`, organizationObject)
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    createAccountDocuments({ commit }, { accountId, files }) {
      return HttpService.postV2(`accounts/${accountId}/documents`, files)
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    async putDocumentToS3({ commit }, { presignedUrl, file }) {
      return axios.put(presignedUrl, file).catch((err) => {
        throw err;
      });
    },
    updateConsentModalFlag() {
      return HttpService.putV2('users/account/consent/confirm')
      .then(response => response)
      .catch((err) => {
        throw err;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/accountCreation.js